import { State } from 'src/redux/reducer';
import { isLoaded, isPending, isRejected, shouldLoad } from 'src/redux/utils';

export const unloadExampleStatusSelector = (state: State) =>
  state.unloadExample.status;
export const unloadExampleErrorSelector = (state: State) =>
  state.unloadExample.error;
export const unloadExampleLoadedSelector = isLoaded(
  unloadExampleStatusSelector,
);
export const shouldLoadunloadExampleSelector = shouldLoad(
  unloadExampleStatusSelector,
);
export const unloadExampleRejectedSelector = isRejected(
  unloadExampleStatusSelector,
);
export const unloadExamplePendingSelector = isPending(
  unloadExampleStatusSelector,
);
